export enum PipelineConfigSyncStatus {
  SUCCESS = "success",
  ERROR = "error",
  PENDING = "pending",
}

export interface PipelineConfigSyncStatusJson {
  status: PipelineConfigSyncStatus;
  error_message?: string;
}
